import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
/* import { BreadcrumbsModule } from 'ng6-breadcrumbs'; */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng7BootstrapBreadcrumbModule } from 'ng7-bootstrap-breadcrumb';
import { BreadcrumbModule } from 'xng-breadcrumb';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

// used to create fake backend
import { JwtInterceptor, ErrorInterceptor } from './auth/_helpers';
// paginas
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { ActivationComponent } from './pages/activation/activation.component';
import { HomeComponent } from './pages/home/home.component';
import { FooterComponent } from './global/footer/footer.component';
import { HeaderComponent } from './global/header/header.component';
import { TablesComponent } from './shared/tables/tables.component';
import { ModalComponent } from './shared/modal/modal.component';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FilterpipePipe } from './shared/filterpipe.pipe';
import { NgbdSortableHeader } from './shared/sortable.directive';
import { NgbModule, NgbNavItem, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { PipesModule } from './shared/pipes/pipes.module';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MaterialModule } from './shared/material/material.module';
import { ForgotPasswordComponent } from './auth/login/forgot-password/forgot-password.component';
import { TimerComponent } from './shared/timer/timer.component';
import { AlertComponent } from './shared/timer/alert/alert.component';
import { VersionControlComponent } from './shared/version-control/version-control.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getPtBrPaginatorIntl } from './shared/pt-br-paginator-intl';
import { AvailableMediaControlComponent } from './shared/available-media/available-media.component';
import { AvailableMediaS3ControlComponent } from './shared/available-media-s3/available-media-s3.component';
import { AvailableDocumentControlComponent } from './shared/available-document/available-document.component';
import { FilterModule } from './shared/filter/filter.module';
import { RelatoriosConteudoComponent } from './pages/relatorios/relatorios-conteudo/relatorios-conteudo.component';
import { RelatoriosColecaoComponent } from './pages/relatorios/relatorios-colecao/relatorios-colecao.component';
import { RelatoriosExternoComponent } from './pages/relatorios/relatorios-externo/relatorios-externo.component';
import { OrderCategoryComponent } from './pages/gestao/highlight/order-category/order-category.component';
import { DatePipe } from '@angular/common';
import { RelatorioDireitosComponent } from './pages/relatorios/relatorio-direitos/relatorio-direitos.component';
import { LastReleasesComponent } from './pages/gestao/highlight/last-releases/last-releases.component';
import { MapsModule } from './shared/maps/maps.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatDatepickerModule } from '@angular/material/datepicker';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

export let options: Partial<IConfig> | (() => Partial<IConfig>);

declare module '@angular/core' {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ActivationComponent,
    HomeComponent,
    FooterComponent,
    TablesComponent,
    ModalComponent,
    FilterpipePipe,
    NgbdSortableHeader,
    HeaderComponent,
    TimerComponent,
    AlertComponent,
    AvailableMediaControlComponent,
    AvailableMediaS3ControlComponent,
    AvailableDocumentControlComponent,
    VersionControlComponent,
    RelatoriosConteudoComponent,
    RelatoriosColecaoComponent,
    RelatoriosExternoComponent,
    OrderCategoryComponent,
    LastReleasesComponent,
    RelatorioDireitosComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    Ng7BootstrapBreadcrumbModule,
    BreadcrumbModule,
    HttpClientModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    MaterialModule,
    NgbNavModule,
    MapsModule,
    NgSelectModule,
    AngularEditorModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMaskModule.forRoot(options),
    PipesModule,
    FilterModule,
    AngularEditorModule,
    MatDatepickerModule
  ],
  providers: [
    DatePipe,
    NgbNavItem,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MatPaginatorIntl, useValue: getPtBrPaginatorIntl() }
  ],
  bootstrap: [AppComponent],
  exports: [NgbdSortableHeader, PipesModule]
})
export class AppModule {}
